module.exports = __webpack_public_path__ + "static/media/appLogo.fa764bed.png";